import CryptoJS from 'crypto-js';

/* eslint-disable array-callback-return */
/**
  |--------------------------------------------------
  | City List for Select
  |--------------------------------------------------
  */
export const getCitySelectList = (list) => {
  let newList = [],
    emptyVo = {}
  emptyVo.value = ''
  emptyVo.label = ''
  newList.push(emptyVo)

  list.map((item) => {
    let objVo = {}
    objVo = item
    objVo.value = item.cityCode
    objVo.label = item.cityDesc
    newList.push(objVo)
  })
  return newList
}

// Encrypt the data and pass it to the header while calling ws
export const ciphertext = CryptoJS.AES.encrypt('ohc279202410396', 'mokavmoemr100').toString();
export const headerData = {
  'Content-Type': 'application/json',
  // 'Authorization': 'Bearer your_token',  // Example of an authorization header
  'Custom-Header': ciphertext,       // Any custom header
};


/**
|--------------------------------------------------
| Array or Object (Handle Response)
|--------------------------------------------------
*/
export const checkArrayOrObject = (passed) => {
  if (Array.isArray(passed)) {
    return passed
  } else if (passed instanceof Object) {
    let objToArr = []
    objToArr.push(passed)
    return objToArr
  } else {
    return passed
  }
}
